import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamsDto } from '../models/TeamsDto.model';

@Injectable({
  providedIn: 'root',
})
export class TeamsService {
  public groupId!: string;
  private baseUrl: string;
  public accessToken: string = '';

  constructor(private http: HttpClient) {
    this.baseUrl = window.location.origin;
  }


  getListOfTeamsData(url: string): Observable<TeamsDto[]> {
    return this.http.get<TeamsDto[]>(url);
  }
}